import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import CategoriesMenu from '../../shared/CategoriesMenu'
import PageCategoriesPostsLayout from '../../shared/PageCategoriesPostsLayout'
import Pagination from '../../shared/Pagination'
import { BLOG_LISTING_PAGE_SIZE } from 'src/services/blogListing/constants'

const BlogPage = ({
  categories = [],
  posts: { items: posts, total, currentPage },
  category,
}) => {
  const categoryTitle = `${category?.title || 'All'} Articles`
  const postData = useMemo(() => {
    if (!posts?.length) {
      return []
    }

    return posts.map((item) => ({
      ...item.model,
      category: item.category,
      path: `/${item.path}`,
      publishedAt: item.updatedAt,
    }))
  }, [posts])

  return (
    <div className="mx-auto mt-2 mb-12 max-w-screen-lg md:mt-0 md:px-3 xl:px-0">
      <div className="m-4 pl-1 md:mx-2 lg:mx-0">
        <CategoriesMenu data={categories} />
      </div>
      <div className="mt-8 mb-5 px-5 md:px-2 lg:mb-8 lg:flex lg:space-x-5 lg:px-0">
        <div className="lg:w/7-10 w-full">
          <PageCategoriesPostsLayout
            data={postData}
            categoryTitle={categoryTitle}
          />
          <Pagination
            itemCount={total}
            currentPageNumber={Number(currentPage)}
            link={category?.slug || ''}
            postsLimit={BLOG_LISTING_PAGE_SIZE}
          />
        </div>
      </div>
    </div>
  )
}

BlogPage.propTypes = {
  categories: PropTypes.array.isRequired,
  posts: PropTypes.object.isRequired,
  sliderData: PropTypes.array,
  category: PropTypes.object,
}

BlogPage.defaultProps = {
  sliderData: null,
  category: null,
}

export default BlogPage
